import { UITexts } from '../../types/ui';

export const uiTexts: UITexts = {
  language: {
    name: "Korean",
    nativeName: "한국어",
    code: "ko",
    flag: "🇰🇷"
  },

  common: {
    loading: "잠시만요...",
    error: "앗, 문제가 생겼어요",
    retry: "다시 해보기",
    back: "뒤로가기",
    next: "다음으로",
    previous: "이전으로",
    finish: "완료하기",
    start: "시작하기",
    restart: "처음부터 다시",
    continue: "계속하기",
    cancel: "취소하기",
    close: "닫기",
    ok: "확인",
    yes: "네",
    no: "아니요",
    save: "저장하기",
    share: "공유하기",
    copy: "복사하기",
    copied: "복사 완료!",
    minutes: "분",
    seconds: "초",
    question: "문제",
    questions: "문제",
    answer: "답",
    answers: "개 답변",
    correct: "정답",
    incorrect: "오답",
    score: "점수",
    time: "시간",
    difficulty: {
      easy: "기초",
      medium: "중급",
      hard: "고급",
      // ISTQB Knowledge levels
      k1: "K1",
      k2: "K2", 
      k3: "K3",
      k4: "K4"
    }
  },

  demo: {
    title: "AI 테스팅",
    subtitle: "체험판",
    description: "AI 테스터 연봉을 받을 준비가 되셨나요? 15분으로 확인해보세요",
    startButton: "내 실력 확인하기",
    badge: "무료 체험판",
    features: {
      title: "정식 버전에서 받으실 수 있는 것들",
      items: [
        "300+ 전문가급 문제",
        "11개 완전한 교육과정 챕터",
        "40분 타이머 시험 시뮬레이션",
        "상세한 답안 설명",
        "성과 분석 및 점수 매기기",
        "여러 번의 연습 세션",
        "즉시 및 평생 이용 가능",
        "모바일 친화적 포맷",
        "보너스: 고급 AI 테스팅 과정 조기 접근"
      ],
      smartQuestions: {
        title: "똑똑한 문제들",
        description: "실무에서 바로 써먹을 수 있는 현실적인 AI 테스팅 시나리오"
      },
      instantFeedback: {
        title: "바로바로 피드백",
        description: "10년+ 경력 실무진의 개인맞춤 설명"
      },
      previewPower: {
        title: "진짜 인증 시뮬레이션",
        description: "정식 인증 과정이 어떤 느낌인지 미리 체험해보세요"
      }
    },
    comparison: {
      demo: {
        title: "무료 체험판",
        features: [
          "엄선된 12문제",
          "핵심 2개 주제", 
          "15분 투자",
          "바로 결과 확인"
        ]
      },
      full: {
        title: "정식판",
        features: [
          "300+ 전문가 문제",
          "완전한 11개 챕터",
          "40분 실제 시험 환경",
          "자세한 분석 리포트",
          "학습 진도 관리"
        ],
        button: "전체 액세스"
      }
    },
    community: "AI 전문가 커뮤니티에 함께해서 인공지능 테스팅의 비밀을 파헤쳐요",
    trustIndicators: "ISTQB 공식 교육과정을 바탕으로 만들어졌어요",
    perfectFor: {
      title: "이런 분들에게 완벽해요",
      items: [
        "AI 테스팅으로 전환하는 QA 엔지니어",
        "기술 스킬셋을 확장하는 소프트웨어 테스터",
        "ISTQB 인증을 추구하는 IT 전문가",
        "AI 테스팅 면접을 준비하는 모든 분",
        "AI 품질 보증에서 업스킬링하는 팀",
        "커리어를 향상시키는 IT 전문가"
      ]
    }
  },

  // Access Page
  access: {
    title: "정식 퀴즈 입장하기",
    subtitle: "액세스 코드 입력",
    description: "300개가 넘는 전문가급 AI 테스팅 문제와 체계적인 시험 준비 과정을 무제한으로 이용하실 수 있어요.",
    form: {
      title: "액세스 코드를 입력해주세요",
      placeholder: "액세스 코드를 여기에 입력하세요...",
      button: "정식판 열기",
      submitting: "확인하는 중..."
    },
    errors: {
      invalid: "앗, 코드가 맞지 않네요. 다시 한번 확인해주실래요?",
      empty: "액세스 코드를 입력해주세요.",
      generic: "뭔가 문제가 생겼어요. 다시 시도해주세요."
    },
    success: {
      title: "입장 허가! 🎉",
      description: "ISTQB AI 테스터 정식판 무제한 이용에 오신 걸 환영해요!",
      validDays: "액세스 권한이 무제한이며 영구적으로 이용 가능해요",
      continueButton: "정식 퀴즈 시작하기"
    },
    purchase: {
      title: "액세스 코드가 없으신가요?",
      subtitle: "지금 바로 권한 받기",
      description: "300개가 넘는 전문가 문제, 자세한 해설, 전체 교육과정을 담은 완전한 ISTQB AI 테스터 퀴즈를 구매하세요.",
      features: [
        "300+ 전문가 문제",
        "완전한 11개 챕터",
        "10년+ 경력 실무진의 개인맞춤 설명",
        "결과 분석",
        "모바일에서도 작동",
        "평생 이용 + 모든 업데이트 무료"
      ],
      button: "인증 준비 시작하기",
      note: "구매 즉시 바로 다운로드"
    },
    security: {
      note: "액세스 코드는 안전하게 암호화되어 보관돼요",
      expiry: "무제한 액세스"
    }
  },

  full: {
    title: "AI Tester 교육",
    subtitle: "AI Tester 퀴즈",
    description: "ISTQB AI 테스팅 교육과정의 11개 챕터를 완벽하게 마스터하세요",
    features: [
      "300+ 전문가 문제",
      "완전한 11개 챕터",
      "실제 시험처럼 40분"
    ],
    welcome: {
      keyFeatures: {
        title: "주요 기능들",
        expertQuestions: {
          title: "300+ 문제",
          features: [
            "전체 커리큘럼 완전 포함",
            "실제 시험과 동일한 형식",
            "다양한 난이도 레벨"
          ]
        },
        adaptiveSystem: {
          title: "똑똑한 시스템",
          features: [
            "개인에 맞춰 조정",
            "적합한 문제 선택",
            "진도 추적"
          ]
        },
        detailedAnalytics: {
          title: "상세한 분석",
          features: [
            "결과 분석",
            "약점 발견",
            "학습 방향 제시"
          ]
        }
      },
      whatMakesDifferent: {
        title: "전문가들이 우리를 선택하는 이유",
        expertCreated: {
          title: "전문가가 직접 만든",
          description: "이론과 실무를 모두 아는 AI 테스팅 실무진들이 문제를 만들었어요"
        },
        completeCoverage: {
          title: "완전한 커버리지",
          description: "ISTQB AI Tester v1.0의 11개 챕터를 낱낱이 분석했어요"
        },
        realScenarios: {
          title: "실제 상황들",
          description: "AI 테스터로 일하면서 꼭 마주치게 될 실무 케이스들"
        },
        trackProgress: {
          title: "진도 추적",
          description: "상세한 분석으로 강점과 약점을 보여드려요"
        }
      },
      perfectFor: {
        title: "이런 분에게 완벽해요",
        items: [
          "AI 테스팅으로 전환하려는 QA 엔지니어",
          "스킬셋을 확장하려는 테스터",
          "ISTQB 인증을 목표로 하는 IT 전문가",
          "AI 테스팅 면접을 준비하는 모든 분",
          "AI 전문성을 키우려는 팀",
          "IT에서 경력을 쌓으려는 전문가"
        ]
      },
      startButton: "인증의 길 시작하기",
      trustIndicators: [
        "전 세계 수천 명의 후보자가 검증"
      ]
    }
  },

  quiz: {
    header: {
      title: "AI Tester 퀴즈",
      timeLeft: "남은 시간",
      progress: "진도",
      streak: "연속"
    },
    navigation: {
      previous: "이전 문제",
      next: "다음 문제", 
      finish: "완료하기",
      questionOverview: "문제 목록",
      swipeHint: "👈 손가락으로 좌우로 스와이프하세요 👉"
    },
    status: {
      answered: "답변함",
      notAnswered: "건너뜀",
      current: "현재 위치"
    }
  },

  results: {
    title: "체험 완료!",
    congratulations: "수고하셨어요!",
    percentage: "% 달성",
    complete: "퀴즈 완료",
    status: {
      passed: "Result",
      failed: "Result",
      retry: "다시 시도",
      pass: "Pass",
      study: "Not Pass"
    },
    performance: {
      genius: "AI 테스팅 천재",
      expert: "AI 테스팅 전문가",
      pro: "AI 테스팅 고수",
      learner: "AI 테스팅 학습자",
      beginner: "AI 테스팅 초보자",
      // Full quiz performance levels
      master: "AI 테스팅 마스터",
      professional: "AI 테스팅 프로페셔널",
      candidate: "AI 테스터 후보",
      // Perfect score level
      perfectMaster: "🎊 절대 마스터 🎊"
    },
    statistics: {
      correct: "정답",
      total: "전체 문제",
      bestStreak: "최고 연속",
      timeSpent: "소요 시간",
      questions: "문제",
      status: "상태"
    },
    actions: {
      showReview: "해설 보기",
      hideReview: "해설 숨기기", 
      tryAgain: "체험판 다시 하기",
      tryAgainNew: "새 문제로 시도하기",
      shareResults: "결과 자랑하기!",
      shareLinkedIn: "LinkedIn에 공유하기"
    },
    sharing: {
      title: "결과를 자랑해보세요! 🎉",
      description: "동료들에게 AI 테스팅 실력을 보여주세요!",
      hashtags: ["ISTQB", "AI테스팅", "인증", "기술스킬", "소프트웨어품질"],
      messages: {
        success: "🎉 완료! LinkedIn이 열렸고, 결과가 복사되었어요!",
        clipboard: "🎉 결과가 클립보드에 복사되었어요!",
        manual: "LinkedIn 게시를 위해 이 텍스트를 복사하세요:"
      },
      // Perfect score sharing
      perfectScore: {
        title: "🎊 완벽한 점수! 🎊",
        description: "게시물에 30% 할인 비밀 해시태그가 있어요!",
        hashtag: "#ainastasiaquizwinner",
        discountOffer: "전체 코스 30% 할인!",
        championText: "이제 공식 AI 테스팅 챔피언이에요!",
        hiddenModeUnlocked: "🎉 와우! 히든 모드를 잠금 해제했어요! 🎉",
        hiddenModeTitle: "히든 모드 활성화!",
        russianCongratulations: "🎉 와우! 히든 모드를 잠금 해제했어요! 🎉",
        perfectScoreMessage: "40문제를 모두 맞춰서 비밀 모드를 잠금 해제했어요!",
        championOfferTitle: "🎁 챔피언을 위한 특별 혜택:",
        specialOffer: "멋진 혜택: 이 게시물을 공유하고 소셜미디어에 게시물 링크와 함께 메시지 보내주시면 — 전체 코스 30% 할인을 받으세요!",
        contactInstructions: "#ainastasiaquizwinner 해시태그로 LinkedIn에 게시하고 게시물 링크와 함께 소셜미디어로 연락주세요 — 메인 코스 30% 할인을 받으실 수 있어요!",
        linkedinButtonHint: "💡 'LinkedIn에 공유하기' 버튼에 비밀 해시태그가 포함된 준비된 텍스트가 있어요"
      }
    },
    upgrade: {
      title: "정식판 준비되셨나요?",
      description: "30% 급여 인상 준비가 되었는지 알아보세요",
      features: [
        "300+ 전문가 문제",
        "완전한 11개 챕터",
        "독특한 문제로 훈련"
      ],
      button: "정식판 받기"
    },
    course: {
      title: "AI 테스팅 이론 마스터 과정",
      subtitle: "📚 실력 업그레이드",
      description: "더 깊이 있게 배우고 싶으시다면? 체계적인 이론 과정에 참여해보세요.",
      features: [],
      button: "얼리버드 특가 받기",
      // Full quiz course promotion
      fullCourse: {
        nextLevel: "🎓 다음 레벨이 기다리고 있어요 🎓",
        masterTitle: "AI 테스팅 이론 마스터 과정",
        masterDescription: "체계적인 이론 과정으로 AI 테스팅 지식을 전문가 수준으로 업그레이드하세요. 무엇을 테스트할지뿐만 아니라 진짜 프로처럼 AI 시스템을 어떻게 테스트하는지 배우세요!",
        bonusTitle: "🎁 퀴즈 참여자 특별 혜택 🎁",
        bonusDescription: "15% 할인 + 독점 학습 자료 제공",
        claimButton: "🔥 지금 특별 혜택 받기 🔥"
      }
    },
    feedback: {
      title: "제품 개선 아이디어가 있으신가요?",
      button: "피드백 남기기"
    },
    social: {
      title: "AI.Nastasia를 팔로우하세요! 🚀",
      description: "커뮤니티에 참여하기",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok", 
        linkedin: "LinkedIn",
        telegram: "Telegram"
      }
    }
  },

  review: {
    title: "답안 해설",
    yourAnswer: "당신의 답:",
    correctAnswer: "정답:",
    explanation: "해설:",
    notAnswered: "건너뜀"
  },

  languageSelector: {
    title: "언어 선택",
    current: "현재 선택됨",
    available: "선택 가능한 언어",
    select: "선택하기"
  },

  mobile: {
    pullToRefresh: "↓ 아래로 당겨서 새로고침 ↓",
    swipeInstructions: "👈 손가락으로 좌우 스와이프 👉",
    tapToSelect: "탭해서 답 선택",
    doubleTapToConfirm: "더블탭으로 확인"
  },

  a11y: {
    languageSelector: "언어 선택",
    questionProgress: "{total} 중 {current}번째 문제",
    optionSelected: "{option}번 선택됨",
    timerWarning: "시간이 거의 다 됐어요",
    resultsSummary: "{score}% 점수로 퀴즈 완료"
  }
};